<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
        <v-card color="#FFD375" class="elevation-12">
            <v-toolbar color="#FFA500">
                <v-toolbar-title>{{title}}</v-toolbar-title>
            </v-toolbar>

            <v-card color="#FFD375" flat class="elevation-12">
                <v-toolbar class="mt-1" color="#FFA500" flat>
                    <v-toolbar-title flat>Available</v-toolbar-title>
                </v-toolbar>
                <v-container :key="selectedcontacts.length">
                    <span v-for="contactchip in availablecontacts" :key="contactchip.ID">
                        <v-chip class="ma-1" @click="chipAvailableClick(contactchip)">{{contactchip.Name}}</v-chip>
                    </span>
                </v-container>
            </v-card>

            <v-card color="#FFD375" flat class="elevation-12">
                <v-toolbar class="mt-1" color="#FFA500" flat>
                    <v-toolbar-title flat>Selected</v-toolbar-title>
                </v-toolbar>
                    <v-container :key="selectedcontacts.length">
                        <span v-for="contactchip in selectedcontacts" :key="contactchip.ID">
                            <v-chip class="ma-1" @click="chipSelectedClick(contactchip)">{{contactchip.Name}}<v-icon right>highlight_off</v-icon></v-chip>
                        </span>
                    </v-container>
            </v-card>

            <v-card-actions>
                <v-btn color="#FFA500" @click="cancel" data-cy="joinSubmitBtn">CANCEL</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="#FFA500" :disabled="!changed" @click="submit" data-cy="joinSubmitBtn">CONFIRM</v-btn>
            </v-card-actions>
        </v-card>
        </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
        value: Boolean,
      group:Object
  },
  data() {
      return {
          changed: false,
          availablecontacts: [],
          selectedcontacts: [],
          originalselectedcontacts:[]
      };
  },
  computed: {
    show: {
        get () {
            this.initialiseData();
            return this.value
        },
        set(value) {
            this.changed = false;
            this.$emit('input', value)
        }
    },
      title() {
        if (!this.group)
            return 'Contacts for';
        return 'Contacts for ' + this.group.Name;
    }
    
  },
  methods: {
      initialiseData() {
          if ((this.group) && (!this.changed))
          {
              this.selectedcontacts = [];
              this.availablecontacts = [];
              this.originalselectedcontacts = [];
              //go through all of my contacts and put them into availablecontacts or selectedcontacts
              this.$store.state.contacts.forEach(contact => {
                  if (this.isSelected(contact.ID)) {
                      this.selectedcontacts.push({ Name: contact.Name, ID: contact.ID });
                      this.originalselectedcontacts.push(contact);
                  }
                  else
                      this.availablecontacts.push({ Name: contact.Name, ID: contact.ID })
              });
              this.availablecontacts.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
              this.selectedcontacts.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          }
      },
      isSelected(id) {
          if ((this.group == null) || (this.group.Contacts == null))
              return false;
          var found = false;
          this.group.Contacts.forEach(grp => {
              if (id === grp)
                  found=true;
          });
          return found;
      },
      inContactList(id,list) {
          var found = false;
          list.forEach(grp => {
              if (id === grp.ID)
                  found = true;
          });
          return found;
      },
      findIndex(id, list) {
          var index = 0;
          var found = -1;
          if (list == null)
              return -1;
          list.forEach(grp => {
              if (id === grp)
                  found = index;
              index++;
          });
          return found;
      },
      chipAvailableClick(chip) {
          const index = this.availablecontacts.indexOf(chip);
          this.availablecontacts.splice(index, 1);
          this.selectedcontacts.push(chip);
          this.selectedcontacts.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          this.changed = true;
      },
      chipSelectedClick(chip) {
          const index = this.selectedcontacts.indexOf(chip);
          this.selectedcontacts.splice(index, 1);
          this.availablecontacts.push(chip);
          this.availablecontacts.sort((a, b) => a["Name"] < b["Name"] ? -1 : 1);
          this.changed = true;
      },
      findMyContact(id) {
          var found = null;
          this.$store.state.contacts.forEach(contact => {
              if (contact.ID === id)
                  found = contact;
          });
          return found;
      },
      cancel(){
          this.show = false;
      },
      submit() {
          // here we action additions 
          this.selectedcontacts.forEach(contact => {
              if (!this.inContactList(contact.ID, this.originalselectedcontacts)) {
                  if (this.group.Contacts == null)
                      this.group.Contacts = [];
                  this.group.Contacts.push(contact.ID);

                  var mycontact = this.findMyContact(contact.ID);
                  const cindex = this.findIndex(this.group.ID, mycontact.Groups);
                  if (cindex < 0) {
                      mycontact.Groups.push(this.group.ID);
                      this.$store.dispatch('setContact', mycontact);
                  }
              };
          });
          // and then removals
          this.originalselectedcontacts.forEach(contact => {
              if (!this.inContactList(contact.ID, this.selectedcontacts)) {
                  const gindex = this.findIndex(contact.ID, this.group.Contacts);
                  this.group.Contacts.splice(gindex, 1);

                  var mycontact = this.findMyContact(contact.ID);
                  const cindex = this.findIndex(this.group.ID, mycontact.Groups);
                  if (cindex >= 0) {
                      mycontact.Groups.splice(cindex, 1);
                      this.$store.dispatch('setContact', mycontact);
                  }
              };
          });
          this.$store.dispatch('setGroup', this.group);
          this.show = false;
        }
  }
}
</script>